module.exports = __webpack_public_path__ + "static/media/QH.027853d3.svg";